import { create } from "zustand";

const useQuestionnaireStore = create((set) => ({
  // --- STEP 1: Main Joint Location ---
  painLocation: null, // e.g., 'Shoulder', 'Knee', 'Back'
  setPainLocation: (location) => set({ painLocation: location }),

  // --- STEP 2: Age Range & Gender ---
  age: null, // e.g., 'Under 18', '18-40', '40-60', '60+'
  setAge: (age) => set({ age: age }),

  gender: null, // 'Male', 'Female', 'Other'
  setGender: (gender) => set({ gender }),

  // --- STEP 3: Precise Location (Specific Part ID) ---
  preciseLocation: null,
  setPreciseLocation: (location) => set({ preciseLocation: location }),

  // --- STEP 4: Pain Duration ---
  painDuration: null, // e.g., '0-6 weeks', '6-12 weeks', '12+ weeks'
  setPainDuration: (duration) => set({ painDuration: duration }),

  // --- STEP 5: Onset of Pain ---
  onset: null, // 'sudden' or 'gradual'
  setOnset: (onset) => set({ onset }),

  onsetDetail: null, // 'activity', 'trauma', 'waking_up' (Only if onset is 'sudden')
  setOnsetDetail: (detail) => set({ onsetDetail: detail }),

  // --- STEP 6: Pain Intensity (NEW) ---
  painIntensity: null, // 0-10 numerical value
  setPainIntensity: (intensity) => set({ painIntensity: intensity }),

  // --- STEP 7: Pain Type (NEW) ---
  painType: null, // e.g., 'dull', 'sharp', 'burning'
  setPainType: (type) => set({ painType: type }),

  // --- STEP 8: Factors (NEW) ---
  aggravatingFactor: [],
  setAggravatingFactor: (factor) => set({ aggravatingFactor: factor }),

  relievingFactor: [],
  setRelievingFactor: (factor) => set({ relievingFactor: factor }),

  // --- STEP 9: Symptoms (NEW) ---
  hasSwelling: null, // boolean
  setHasSwelling: (value) => set({ hasSwelling: value }),

  worsensWithPressure: null, // boolean
  setWorsensWithPressure: (value) => set({ worsensWithPressure: value }),

  // --- STEP 10: Medical History (NEW) ---
  medicalConditions: [], // Array of strings
  setMedicalConditions: (conditions) => set({ medicalConditions: conditions }),

  // --- STEP 11: Contact Info (NEW) ---
    email: "",
    setEmail: (email) => set({ email }),

  // --- UTILITY: Reset Store ---
  // Clears all state to start the questionnaire over
  resetStore: () =>
    set({
      painLocation: null,
      age: null,
      gender: null,
      preciseLocation: null,
      painDuration: null,
      onset: null,
      onsetDetail: null,
      painIntensity: null,
      painType: null,
      aggravatingFactor: [],
      relievingFactor: [],
      hasSwelling: null,
      worsensWithPressure: null,
      medicalConditions: [],
      email: ""
    }),
}));

export default useQuestionnaireStore;
